import React from 'react';
// ANT
//
import timezone from 'moment-timezone';
// COMPONENTS
import InvoiceItem from './InvoiceItem';
import CurrencyHelpers from 'lib/helpers/CurrencyHelpers';
import Title from 'components/text/Title';

const USER_TIMEZONE = timezone.tz.guess() || 'America/New_York';

class InvoiceList extends React.PureComponent {
  createInvoiceItem = ({
    _id, description, amount, currencySymbol, due,
  }) => ({
    _id,
    description,
    amount: CurrencyHelpers.centsToDollars(amount, { symbol: currencySymbol }),
    due: timezone(due || new Date())
      .tz(USER_TIMEZONE)
      .format('dddd, MMMM D'),
  });

  getExistingInvoices = () => {
    const { invoices, currencySymbol } = this.props;

    if (!invoices || !invoices.length || !invoices.length === 0) {
      return null;
    }

    let invoiceList = [];

    invoices.forEach(invoice => {
      let item = this.createInvoiceItem({
        _id: invoice._id,
        description: '',
        currencySymbol,
        amount: invoice.finalPaymentAmount,
        due: invoice.due,
      });
      invoiceList.push(item);
    });

    return invoiceList;
  };

  getInvoicesList = () => {
    const {
      finalPaymentAmount,
      depositAmount,
      finalPaymentDueDate,
      depositDueDate,
      currencySymbol,
      invoices,
    } = this.props;

    let invoiceList = [];

    // if invoices already exist, such as in the case of editing a saved contract, than we just grab the existing invoices,
    if (invoices && invoices.length && invoices.length > 0) {
      return this.getExistingInvoices();
    }

    // if we don't have existing invoices, we will build some invoice objects based on the contract form state.

    console.log(depositAmount === '0');

    if (depositAmount && depositAmount !== 0 && depositAmount !== '0') {
      let invoice1 = this.createInvoiceItem({
        _id: '1',
        description: 'Deposit',
        amount: depositAmount,
        currencySymbol,
        due: depositDueDate,
      });
      invoiceList.push(invoice1);
    }

    if (finalPaymentAmount) {
      let invoice2 = this.createInvoiceItem({
        _id: '2',
        description: 'Payment for work',
        amount: finalPaymentAmount,
        currencySymbol,
        due: finalPaymentDueDate,
      });
      invoiceList.push(invoice2);
    }

    return invoiceList;
  };

  render() {
    let invoiceList = this.getInvoicesList();

    return (
      <div style={{ padding: 25, background: '#fff' }}>
        <Title style={{ marginBottom: 20 }}>
          {this.props.header
            ? this.props.header
            : `We'll create ${invoiceList.length} invoice${invoiceList.length > 1 ? 's' : ''} for this project:`}
        </Title>
        {invoiceList.map((invoice, index) => (
          <InvoiceItem key={invoice._id} invoice={invoice} index={index} onCancelInvoice={this.props.onCancelInvoice} />
        ))}
      </div>
    );
  }
}

export default InvoiceList;



// WEBPACK FOOTER //
// ./src/routes/contract-draft/InvoicesInfo/InvoiceList/index.js